import type {
  ConnectedTemplate as ConnectedTemplateDto,
  PatchAction,
  Path as PathDto,
  Relation as RelationDto,
  RelationRequest,
  Relative as RelativeDto,
} from '@mynt/backoffice-api-spec/templates'
import {
  type CreateRelationRequest,
  EditRelationOperation,
  type Path,
  type Relation,
  type RelationId,
  type RelationTemplate,
  type RelationUpdateRequest,
  type Relative,
  type TemplateId,
} from './api'

export const mapUpdateRelationRequestToPatchAction = (request: RelationUpdateRequest): PatchAction => {
  switch (request.op) {
    case EditRelationOperation.ADD:
      return {
        op: 'add',
        templateId: request.templateId,
      }
    case EditRelationOperation.REMOVE:
      return {
        op: 'remove',
        templateId: request.templateId,
      }
    case EditRelationOperation.ADD_ALLOWED_PATH:
      return {
        op: 'addAllowedPath',
        from: request.from,
        to: request.to,
      }
    case EditRelationOperation.REMOVE_ALLOWED_PATH:
      return {
        op: 'removeAllowedPath',
        from: request.from,
        to: request.to,
      }
  }
}

export const mapRelationToRelationDto = (relation: Relation): RelationDto => ({
  id: relation.id,
  name: relation.name,
  relatives: relation.relatives.map(mapRelativeToRelativeDto),
  allowedPaths: relation.allowedPaths.map(mapPathToPathDto),
})

export const mapCreateRelationRequestToRelationRequestDto = (relation: CreateRelationRequest): RelationRequest => ({
  name: relation.name,
  relations: relation.relatives,
})

export const mapRelativeToRelativeDto = (relative: Relative): RelativeDto => ({
  id: relative.id,
  name: relative.name,
  externalName: relative.externalName,
})

export const mapRelationDtoToRelation = (relationDto: RelationDto): Relation => ({
  id: relationDto.id as RelationId,
  name: relationDto.name,
  relatives: relationDto.relatives.map(mapRelativeDtoToRelative),
  allowedPaths: relationDto.allowedPaths.map(mapPathDtoToPath),
})

export const mapPathToPathDto = (path: Path): PathDto => ({
  from: path.from,
  to: path.to,
})

export const mapPathDtoToPath = (pathDto: PathDto): Path => ({
  from: pathDto.from as TemplateId,
  to: pathDto.to as TemplateId,
})

export const mapRelativeDtoToRelative = (relativeDto: RelativeDto): Relative => ({
  id: relativeDto.id as TemplateId,
  name: relativeDto.name,
  externalName: relativeDto.externalName,
})

export const mapConnectedTemplateDtoToRelationTemplate = (templateDto: ConnectedTemplateDto): RelationTemplate => ({
  templateId: templateDto.id as TemplateId,
  internalName: templateDto.name,
  externalName: templateDto.externalName,
  connections: templateDto.numberOfConnections,
})
